import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const listRowStyle = recipe({
  base: {
    display: "flex",
    textAlign: "left",
    alignContent: "center",
    alignItems: "center",
  },
  variants: {
    variant: {
      default: {
        "@container": {
          "card (max-width: 500px)": {
            paddingLeft: 0,
            paddingRight: 0,
            flexWrap: "wrap",
          },
        },
        selectors: {
          "&:last-child": {
            paddingBottom: 0,
          },
        },
      },
      primary: {
        backgroundColor: theme.colors.background,
        color: theme.colors.onBackground,
        minHeight: rem(56),
      },
      secondary: {
        minHeight: rem(56),
      },
      compact: {},
    },
    size: {
      s: {
        borderRadius: theme.borderRadiuses.s,
        padding: theme.spacings.xs,
        gap: theme.spacings.xs,
      },
      plain: {
        borderRadius: theme.borderRadiuses.s,
        gap: theme.spacings.xs,
        padding: theme.spacings.s,
      },
      m: {
        borderRadius: theme.borderRadiuses.s,
        padding: theme.spacings.xs,
        gap: theme.spacings.s,
      },
      l: {
        padding: theme.spacings.s,
        gap: theme.spacings.m,
      },
    },
  },
  defaultVariants: {
    variant: "default",
    size: "s",
  },
});

export const edgesStyle = style({
  overflow: "hidden",
  "@container": {
    "card (max-width: 500px)": {},
  },
});

export const trailingEdgeStyle = recipe({
  base: {},
  variants: {
    variant: {
      compact: {},
    },
  },
});
